import React, { useEffect } from 'react'

import { useAuthFromCode } from 'conversations/hooks/useAuthFromCode'
import { setupDevAuth } from 'conversations/utils/auth'
import { History } from 'history'
import { Route, RouteComponentProps, RouteProps, withRouter } from 'react-router'

import { getAccessToken, setAccessToken } from '@driftt/web-auth'

if (process.env.NODE_ENV === 'development' && !window.Cypress) {
  setupDevAuth()
}

interface Props extends RouteComponentProps {
  route: RouteProps
  onUnauthed: (history: History) => void
}

export const PrivateRouteComponent = ({
  route: { component: Component, ...rest },
  onUnauthed,
  history,
}: Props) => {
  const urlSearch = new URLSearchParams(history.location.search)
  const token = urlSearch.get('token')
  const authorizationCode = urlSearch.get('code')
  const fetchingAuthCode = useAuthFromCode(authorizationCode)

  if (token) {
    setAccessToken({ token })
  }

  if (!Component) {
    throw Error('component is undefined')
  }

  useEffect(() => {
    if (!fetchingAuthCode && !getAccessToken()) {
      onUnauthed(history)
    }
  }, [fetchingAuthCode, onUnauthed, history])

  const render = (props: RouteComponentProps<any>): React.ReactNode => {
    return getAccessToken() && <Component {...props} />
  }

  return <Route {...rest} render={render} />
}

export const PrivateRoute = withRouter(PrivateRouteComponent)
